module.exports = __webpack_public_path__ + "static/main-665ba9c30e602d4524cca1bc4becc53f.png";